export function Field({ label, name, type = "text", value, onChange, required, placeholder, testId }) {
  return (
    <label className="block group">
      <span className="label block mb-3">
        {label}
        {required && <span className="text-silver/50"> *</span>}
      </span>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        data-testid={testId}
        className="w-full bg-transparent border-b border-charcoal pb-3 text-warm font-light text-base placeholder:text-silver/30 focus:outline-none focus:border-warm transition-colors duration-500"
      />
    </label>
  );
}

export function TextArea({ label, name, value, onChange, required, rows = 3, testId }) {
  return (
    <label className="block">
      <span className="label block mb-3">
        {label}
        {required && <span className="text-silver/50"> *</span>}
      </span>
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        rows={rows}
        data-testid={testId}
        className="w-full bg-transparent border-b border-charcoal pb-3 text-warm font-light text-base resize-none focus:outline-none focus:border-warm transition-colors duration-500"
      />
    </label>
  );
}

export function SelectField({ label, name, value, onChange, required, options, testId }) {
  return (
    <label className="block">
      <span className="label block mb-3">
        {label}
        {required && <span className="text-silver/50"> *</span>}
      </span>
      <select
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        data-testid={testId}
        className="w-full bg-transparent border-b border-charcoal pb-3 text-warm font-light text-base focus:outline-none focus:border-warm transition-colors duration-500 [&>option]:bg-ink"
      >
        <option value="" className="bg-ink text-silver">Select</option>
        {options.map((o) => (
          <option key={o} value={o} className="bg-ink text-warm">
            {o}
          </option>
        ))}
      </select>
    </label>
  );
}
